'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
} // Combine all the builders to make the bulk of what index.css was. Basically an index of className
// values that will turn into the style.
// styles.pt3 == { paddingTop: '3rem' }


exports.default = _extends({}, _merge3.default.apply(undefined, [{}].concat(_toConsumableArray((0, _map3.default)(_utils.remStyles, _utils.remStyleBuilder)))), (0, _utils.remStyleBuilder)('margin', 'm', ['margin', '']), (0, _utils.remStyleBuilder)('padding', 'p', ['padding', '']), (0, _utils.remStyleBuilder)('borderWidth', 'bw', ['border', 'Width']), {
  absolute: (0, _utils.pos)('absolute'),
  b: {
    fontWeight: 'bold'
  },
  bn: (0, _merge3.default)((0, _utils.allSides)('border', 'Style', 'none'), (0, _utils.allSides)('border', 'Width')),
  ba: _extends({
    borderStyle: 'solid'
  }, (0, _utils.allSides)('border', 'Width')),
  bb: {
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px'
  },
  bbn: {
    borderBottom: 'none'
  },
  bgGray: (0, _utils.bgColor)('#eee'),
  bgWashedBlue: (0, _utils.bgColor)('#f6fffe'),
  bgTrans: {
    background: 'transparent'
  },
  bl: {
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px'
  },
  bln: {
    borderLeft: 'none'
  },
  block: (0, _utils.disp)('block'),
  bottom0: {
    bottom: 0
  },
  br: {
    borderRightStyle: 'solid',
    borderRightWidth: '1px'
  },
  brn: {
    borderRight: 'none'
  },
  bt: {
    borderTopStyle: 'solid',
    borderTopWidth: '1px'
  },
  btn: {
    borderTop: 'none'
  },
  column: _utils.floatLeft,
  columnRtl: _utils.floatRight,
  contentAround: (0, _utils.algnCnt)('space-around'),
  contentCenter: (0, _utils.algnCnt)('center'),
  contentEnd: (0, _utils.algnCnt)('flex-end'),
  contentBetween: (0, _utils.algnCnt)('space-between'),
  contentStart: (0, _utils.algnCnt)('flex-start'),
  contentStretch: (0, _utils.algnCnt)('stretch'),
  fixed: (0, _utils.pos)('fixed'),
  fl: _utils.floatLeft,
  flex: (0, _utils.disp)('flex')
}, (0, _utils.buildNumSizes)('flex', 'flex'), {
  flexAuto: {
    flex: '1 1 auto',
    minWidth: 0,
    minHeight: 0
  },
  flexColumn: {
    flexDirection: 'column'
  },
  flexNone: {
    flex: 'none'
  },
  flexRow: {
    flexDirection: 'row'
  },
  flexWrap: {
    flexWrap: 'wrap'
  },
  fr: _utils.floatRight,
  h100: {
    height: '100%'
  },
  h100vh: {
    height: '100vh'
  },
  i: {
    fontStyle: 'italic'
  },
  inlineBlock: {
    display: 'inline-block'
  },
  itemsBaseline: {
    alignItems: 'baseline'
  },
  itemsCenter: {
    alignItems: 'center'
  },
  itemsEnd: {
    alignItems: 'flex-end'
  },
  itemsStart: {
    alignItems: 'flex-start'
  },
  itemsStretch: {
    alignItems: 'stretch'
  },
  justifyAround: {
    justifyContent: 'space-around'
  },
  justifyBetween: {
    justifyContent: 'space-between'
  },
  justifyCenter: {
    justifyContent: 'center'
  },
  justifyEnd: {
    justifyContent: 'flex-end'
  },
  justifyStart: {
    justifyContent: 'flex-start'
  },
  left0: {
    left: 0
  },
  left1: {
    left: '1rem'
  },
  left50p: _utils.left50p,
  left1p5: {
    left: '1.5rem'
  },
  lsInline: {
    display: 'flex',
    justifyContent: 'center'
  },
  lsNone: {
    listStyle: 'none'
  },
  mlrauto: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  mlneg2: {
    marginLeft: '-2rem'
  },
  mrneg2: {
    marginRight: '-2rem'
  },
  mw100p: {
    maxWidth: '100%'
  },
  mw1: {
    maxWidth: '1rem'
  },
  mw2: {
    maxWidth: '2rem'
  },
  mw3: {
    maxWidth: '4rem'
  },
  mw4: {
    maxWidth: '8rem'
  },
  mw5: {
    maxWidth: '16rem'
  },
  mw6: {
    maxWidth: '32rem'
  },
  mw7: {
    maxWidth: '48rem'
  },
  mw8: {
    maxWidth: '64rem'
  },
  mw9: {
    maxWidth: '96rem'
  },
  mwNone: {
    maxWidth: 'none'
  }
}, (0, _utils.buildNumSizes)('order', 'order'), {
  orderLast: {
    order: 99999
  },
  pos: _utils.pos,
  positionCenterX: (0, _merge3.default)({
    transform: 'translateX(-50%)'
  }, _utils.left50p),
  positionCenterY: (0, _merge3.default)({
    transform: 'translateY(-50%)'
  }, _utils.top50p),
  positionCenter: (0, _merge3.default)({
    transform: 'translate(-50%,-50%)'
  }, _utils.top50p, _utils.left50p),
  relative: (0, _utils.pos)('relative'),
  right0: {
    right: 0
  },
  static: (0, _utils.pos)('static'),
  selfBaseline: {
    alignSelf: 'baseline'
  },
  selfCenter: {
    alignSelf: 'center'
  },
  selfEnd: {
    alignSelf: 'flex-end'
  },
  selfStart: {
    alignSelf: 'flex-start'
  },
  selfStretch: {
    alignSelf: 'stretch'
  },
  textCenter: {
    textAlign: 'center'
  },
  textLeft: {
    textAlign: 'left'
  },
  textRight: {
    textAlign: 'right'
  },
  textReset: {
    textDecoration: 'none',
    textShadow: 'none',
    textTransform: 'none',
    letterSpacing: 'normal'
  },
  textStrike: {
    textDecoration: 'line-through'
  },
  textUnderline: {
    textDecoration: 'underline'
  },
  textNoUnderline: {
    textDecoration: 'none'
  },
  top0: {
    top: 0
  },
  top1: {
    top: '1rem'
  },
  top50p: _utils.top50p,
  w50: {
    width: '50%'
  },
  w100vw: {
    width: '100vw'
  },
  w100: {
    width: '100%'
  }
}, (0, _utils.buildNumSizes)('zIndex', 'z'));
module.exports = exports['default'];